/* global debounce */

if (!customElements.get('blog-predictive-search')) {
  class BlogPredictiveSearch extends HTMLElement {
    constructor() {
      super();
      this.cachedResults = {};
      this.input = this.querySelector('.js-search-input');
      this.resetBtn = this.querySelector('.js-search-reset');
      this.results = this.querySelector('.js-blog-search-results');
      this.addListeners();
    }

    addListeners() {
      this.input.addEventListener('input', debounce(this.handleInput.bind(this)));
      this.input.addEventListener('keydown', this.handleKeydown.bind(this));
      this.input.addEventListener('focus', this.handleFocus.bind(this));
      if (this.resetBtn) {
        this.resetBtn.addEventListener('click', this.handleReset.bind(this));
      }
      document.addEventListener('click', (evt) => {
        if (!this.contains(evt.target)) this.close();
      });
    }

    getQuery() {
      return this.input.value.trim();
    }

    handleFocus() {
      if (this.getQuery().length && this.getAttribute('results') === 'true') {
        this.open();
      }
    }

    handleInput() {
      this.input.setAttribute('value', this.input.value);
      const searchTerm = this.getQuery();
      if (this.resetBtn) {
        this.resetBtn.hidden = !searchTerm.length;
      }
      if (!searchTerm.length) {
        this.close();
        return;
      }
      this.getResults(searchTerm);
    }

    handleReset() {
      this.input.value = '';
      this.input.setAttribute('value', '');
      if (this.resetBtn) this.resetBtn.hidden = true;
      this.close();
      this.input.focus();
    }

    handleKeydown(evt) {
      switch (evt.key) {
        case 'ArrowUp':
        case 'ArrowDown':
          evt.preventDefault();
          if (this.hasAttribute('open')) this.handleResultsNav(evt.key);
          break;
        case 'Enter':
          this.selectOption();
          break;
        case 'Escape':
          this.close();
          this.input.blur();
          break;
        // no default
      }
    }

    handleResultsNav(key) {
      const allResults = this.querySelectorAll('.predictive-search__item');
      const selected = this.querySelector('.predictive-search__item[aria-selected="true"]');
      let next;

      if (key === 'ArrowDown') {
        next = selected ? selected.nextElementSibling || allResults[0] : allResults[0];
      } else {
        if (!selected) return;
        next = selected.previousElementSibling || allResults[allResults.length - 1];
      }

      if (next && next !== selected) {
        next.setAttribute('aria-selected', 'true');
        if (selected) selected.setAttribute('aria-selected', 'false');
      }
    }

    selectOption() {
      const selected = this.querySelector('.predictive-search__item[aria-selected="true"] > a');
      if (selected) selected.click();
    }

    async getResults(searchTerm) {
      const queryKey = searchTerm.toLowerCase();
      if (this.cachedResults[queryKey]) {
        this.renderResults(this.cachedResults[queryKey]);
        return;
      }

      let searchParams = `q=${encodeURIComponent(searchTerm)}`;
      searchParams += `&${encodeURIComponent('resources[type]')}=article`;
      searchParams += `&${encodeURIComponent('resources[limit]')}=6`;
      searchParams += '&section_id=predictive-search-blog';

      try {
        const response = await fetch(`${theme.routes.predictiveSearch}?${searchParams}`);
        if (!response.ok) throw new Error(response.status);

        const tmpl = document.createElement('template');
        tmpl.innerHTML = await response.text();

        const resultsEl = tmpl.content.querySelector('#shopify-section-predictive-search-blog');
        const resultsMarkup = resultsEl ? resultsEl.innerHTML : '';

        this.cachedResults[queryKey] = resultsMarkup;
        this.renderResults(resultsMarkup);
      } catch (error) {
        this.close();
        throw error;
      }
    }

    renderResults(resultsMarkup) {
      this.results.innerHTML = resultsMarkup;
      const hasContent = this.results.querySelector('.predictive-search__item, .predictive-search__no-results');
      if (hasContent) {
        this.setAttribute('results', 'true');
        this.open();
      } else {
        this.close();
      }
    }

    open() {
      this.setAttribute('open', '');
      this.input.setAttribute('aria-expanded', 'true');
    }

    close() {
      this.removeAttribute('open');
      this.input.setAttribute('aria-expanded', 'false');
    }
  }

  customElements.define('blog-predictive-search', BlogPredictiveSearch);
}
